const { InnerBlocks } = wp.blockEditor;

export default function save({ attributes }) {
  const { tabsHeading, margin } = attributes;

  return (
    <div className={`tab-section ${margin}`}>
      <div className="Tab Container">
        {tabsHeading.map((heading) => {
          if (!heading.title) return null;

          return (
            <button
              id={heading.tabId}
              className="tablinks pagetab"
              data-url-id={heading.urlId}
            >
              {heading.title}
            </button>
          );
        })}
      </div>

      <div>
        <InnerBlocks.Content />
      </div>
    </div>
  );
}
